module.exports = __webpack_public_path__ + "img/Jump Casting104.304d7aba.jpg";